import { render, staticRenderFns } from "./CardProjetosEncerrados.vue?vue&type=template&id=f67572e4&"
import script from "./CardProjetosEncerrados.vue?vue&type=script&lang=js&"
export * from "./CardProjetosEncerrados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports